(ns ycweb.app.website.products.components.content-panels
  (:require
   [rum.core :as rum]
   [ycweb.components.common :as cmn]
   [ycweb.components.grid :as grid]
   [ycweb.components.scroll :as scroll]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as yuc]
   [util.transform :as trf]))

;; $breakpoint-l = 62.5em = 1000px at default 16px base
(def ^:private desktop-breakpoint 1000)

(defn- desktop? []
  #?(:cljs (>= (.-innerWidth js/window) desktop-breakpoint)
     :clj true))

(defn open-panel
  "Opens a panel by key. On desktop, scrolls to the inline element instead."
  [process-atom panel-key]
  #?(:cljs
     (if (desktop?)
       (scroll/scroll-to-id nil (str "js-product-" (name panel-key)))
       (do
         (swap! process-atom assoc :open-panel panel-key)
         (.add (.-classList (.-body js/document)) "body--no-scroll")))
     :clj nil))

(defn close-panel [process-atom]
  (swap! process-atom assoc :open-panel nil)
  #?(:cljs
     (.remove (.-classList (.-body js/document)) "body--no-scroll")
     :clj nil))

(rum/defc content-panel < rum/reactive
  "Shared wrapper for all content panels. Renders the overlay + panel chrome
   (header with title and close button, scrollable content pane).
   On mobile: slide-out modal with overlay. On desktop: inline content (CSS handles this)."
  [{:keys [panel-key title process-atom]} & children]
  (let [open-panel-key (cmn/curact process-atom :open-panel)
        is-open? (= open-panel-key panel-key)]
    [:div.product-panel-container
     [:div.product-content-wrapper
      [:div
       {:id (str "js-product-" (name panel-key))
        :class
        (cond-> "product-content"
          is-open? (str " product-content--is-open"))}
       [:div.product-content__header
        [:h2.product-content__heading title]
        [:button.product-content__close-button
         {:on-click #(close-panel process-atom)
          :type "button"}
         [:i.icon.icon--block.icon--default.icon--is-dark.icon--close]
         [:span.u-hidden-from-view "Close"]]]
       (into [:div.product-content__pane.yc-product-copy] children)]]
     [:div
      {:class
       (cond-> "product-content-overlay"
         is-open? (str " product-content-overlay--is-open"))
       :on-click #(close-panel process-atom)}]]))

(defn- wrap-html [html-str]
  [:div {:dangerouslySetInnerHTML {:__html html-str}}])

(rum/defc product-info-panel < rum/reactive [process-atom]
  (let [product (cmn/curact process-atom :product)
        {:keys [teaser summary content]} product]
    (when (or (yuc/presence teaser) (yuc/presence summary) (yuc/presence content))
      (content-panel {:panel-key :info :title "Product info" :process-atom process-atom}
        [:div.yc-simple-text
         (when (yuc/presence teaser)
           (wrap-html (str "<p>" teaser "</p>")))
         (when (yuc/presence summary)
           (wrap-html summary))
         (when (yuc/presence content)
           (wrap-html content))]))))


(rum/defc specs-panel < rum/reactive [process-atom]
  (let [{:keys [specs]} (cmn/curact process-atom :product)]
    (when (yuc/presence specs)
      (content-panel {:panel-key :specs :title "Product specifications" :process-atom process-atom}
        [:div.yc-simple-text
         (wrap-html specs)]))))

;; JWPlayer / BOTR — production currently serves product videos from this network.
;; PHP uses the same endpoints in views/templates/yuppiechef/shared/content/show/botrvideos.tpl.
(def ^:private jwplayer-id "kUV6BPcS")

(defn video-player-url [videokey]
  (str "https://content.bitsontherun.com/players/" videokey "-" jwplayer-id ".html"))

(defn- video-thumb-url [videokey size]
  (str "https://content.bitsontherun.com/thumbs/" videokey "-" size ".jpg"))

(rum/defcs videos-panel < rum/reactive
  (rum/local {:idx 0 :playing? false} ::state)
  [local-state process-atom]
  (let [product (cmn/curact process-atom :product)
        videos (:videos product)
        videocount (or (:product/video-count product) (count videos))]
    (when (seq videos)
      (let [s (::state local-state)
            {:keys [idx playing?]} @s
            current (nth videos (or idx 0) (first videos))
            multi? (> videocount 1)
            play! (fn [i]
                    (fn [e]
                      (.preventDefault e)
                      (swap! s assoc :idx i :playing? true)))]
        (content-panel {:panel-key :videos
                        :title (if multi? "Videos" "Video")
                        :process-atom process-atom}
          [:div.video-gallery.u-block-center.u-max-width-720
           [:div.video-gallery__media-wrapper
            (if playing?
              [:div.responsive-iframe-wrapper.responsive-iframe-wrapper--16x9
               [:iframe
                {:src (video-player-url (:video/video-key current))
                 :style {:width "100%"}
                 :frameBorder "0"
                 :allow "fullscreen; picture-in-picture"
                 :allowFullScreen ""}]]
              [:a.js-videolink.block-link.video-gallery__preview-link
               {:href "#" :on-click (play! (or idx 0))}
               [:img.video-gallery__preview-image.yc-simple-image.yc-simple-image--full
                {:src (video-thumb-url (:video/video-key current) "720")
                 :alt (str "Preview image of " (or (:video/title current) "product") " video")}]
               [:i.icon.icon--play-circle.icon--is-light.icon--default.icon--block.video-gallery__play-icon
                [:span.u-hidden-from-view "Play Video"]]])]
           (when multi?
             [:ul.video-gallery-playlist
              (for [[i v] (map-indexed vector videos)]
                [:li.video-gallery-playlist__item {:key (:video/id v)}
                 [:a.video-gallery-playlist__link
                  {:href "#" :on-click (play! i)}
                  [:div.video-gallery-playlist__hero
                   [:img.yc-simple-image.yc-simple-image--full
                    {:src (video-thumb-url (:video/video-key v) "120") :alt ""}]]
                  [:span.video-gallery-playlist__text (:video/title v)]
                  [:i {:class
                       (str "video-gallery-playlist__icon icon icon--block icon--default icon--is-dark "
                         (if (and playing? (= i idx)) "icon--success" "icon--play-circle"))}]]])])])))))


(rum/defc features-panel < rum/reactive [process-atom]
  (let [product (cmn/curact process-atom :product)
        variation (cmn/curact process-atom :variation)
        {:keys [features]} product
        content-name (:product/content-name product)
        {:variation/keys [exclusive feature1 feature2 feature3 barcode]} variation
        variation-name (:variation/name variation)
        is-exclusive? (= exclusive true)
        has-colour? (yuc/presence feature2)
        has-variant? (or (yuc/presence feature1) (yuc/presence feature3))]
    (content-panel {:panel-key :features :title "Key features" :process-atom process-atom}
      [:div.yc-simple-text
       [:table.specs-table
        [:caption.u-hidden-from-view (str "Key features of the " content-name)]
        [:colgroup
         [:col {:style {:width "25%"}}]
         [:col]]
        [:tbody
         (when is-exclusive?
           [:tr.specs-table__tr
            [:th.specs-table__th {:scope "row" :col-span 2}
             (cond
               has-colour?
               [:span "This colour is "]

               has-variant?
               [:span "This variant is "])
             [:span "exclusive to Yuppiechef"]]])
         (cond
           has-colour?
           [:tr.specs-table__tr
            [:th.specs-table__th {:scope "row"} "Product colour:"]
            [:td.specs-table__td feature2]]

           has-variant?
           [:tr.specs-table__tr
            [:th.specs-table__th {:scope "row"} "Product variant:"]
            [:td.specs-table__td (or feature1 feature3)]])
         [:tr.specs-table__tr
          [:th.specs-table__th {:scope "row"} "Product SKU code:"]
          [:td.specs-table__td variation-name]]
         [:tr.specs-table__tr
          [:th.specs-table__th {:scope "row"} "Product barcode:"]
          [:td.specs-table__td barcode]]
         [:tr.specs-table__tr
          [:th.specs-table__th {:scope "row"} "Product condition:"]
          [:td.specs-table__td "New"]]
         (when (seq features)
           (for [feat (if (map? features) (vals features) features)]
             [:tr.specs-table__tr {:key (:description feat)}
              [:th.specs-table__th {:scope "row"} (str (:description feat) ":")]
              [:td.specs-table__td (:formattedvalue feat)]]))]]]
      [:p.yc-paragraph.yc-paragraph--small.u-margin-top-16
       "Note: Some images are shown to illustrate scale, usage or features of the product, and may not be of the specific variant selected."])))


(rum/defc care-panel < rum/reactive [process-atom]
  (let [{:keys [care]} (cmn/curact process-atom :product)]
    (when (yuc/presence care)
      (content-panel {:panel-key :care :title "Care instructions" :process-atom process-atom}
        [:div.yc-simple-text
         (wrap-html care)]))))


(rum/defc warranty-panel < rum/reactive [process-atom]
  (let [{:keys [warranty]} (cmn/curact process-atom :product)]
    (when (yuc/presence warranty)
      (content-panel {:panel-key :warranty :title "Warranty" :process-atom process-atom}
        [:div.yc-simple-text
         (wrap-html warranty)]))))


(rum/defc downloads-panel < rum/reactive [process-atom]
  (let [{:keys [download]} (cmn/curact process-atom :product)]
    (when (seq download)
      (content-panel {:panel-key :downloads :title "Downloads" :process-atom process-atom}
        [:div.yc-simple-text
         [:ul
          (for [{:download/keys [url description]} download]
            [:li {:key url}
             [:a.text-link {:href url :target "_blank" :rel "noopener"}
              (or description "Download")]])]]))))

(def ^:private help-article-delivery-charges 181)
(def ^:private help-article-delivery-times 38)
(def ^:private help-article-order-collections 29)
(def ^:private help-article-postnet-collections 117)
(def ^:private help-article-sending-as-gift 322)
(def ^:private help-article-returns-policy 155)
(def ^:private help-article-dropship-deliveries 189)


(defn open-help-article
  "Fetch a help article by ID and open it in a modal. Shows the page-level
   loading overlay while the ajax request is in flight; the receive handler
   closes it before rendering the modal."
  [app-atom article-id]
  (toaster/open-overlay app-atom :web.product/loading)
  (comms/ajax-get :web.product/help-article
    {:help-article
     #:help-article
      {:id article-id
       :user-id (cmn/curact app-atom [:user :refid])}}))

(defmethod comms/receive :web.product/help-article [app-atom {:keys [help-article]}]
  (toaster/close-overlay app-atom :web.product/loading)
  (when help-article
    (grid/open-modal app-atom :web.product/help-article
      {:config {:title (:help-article/display-name help-article)
                :body (:help-article/body help-article)}})))

(rum/defc help-article-modal-body < rum/reactive [_app-atom config-atom _]
  (let [{:keys [body]} (cmn/curact config-atom [:config])]
    [:div.modal__content
     [:div.yc-simple-text
      {:dangerouslySetInnerHTML {:__html (or body "")}}]]))

(defmethod grid/modal-config :web.product/help-article [_ _ _]
  {:body help-article-modal-body
   :modal-type :variable})

(defn- help-link [app-atom article-id _article-name _title text]
  [:a.text-link
   {:href (str "/help.htm?action=article&id=" article-id)
    :on-click
    (fn [e]
      (.preventDefault e)
      (open-help-article app-atom article-id))}
   text])

(rum/defc shipping-panel < rum/reactive [app-atom process-atom]
  (let [product (cmn/curact process-atom :product)
        variation (cmn/curact process-atom :variation)
        {:keys [geofenced_snippet]} product
        dropship? (trf/toboolean (:product/is-dropship product))
        price (or (:variation/price variation) 0)
        delivery-threshold (or (cmn/curact process-atom :delivery-threshold) 0)
        qualifies-free? (> price delivery-threshold)]
    (content-panel {:panel-key :shipping :title "Shipping & returns" :process-atom process-atom}
      [:div.yc-simple-text
       [:h3 "Delivery"
        (when dropship?
          [:span " \u2014 ships directly from supplier"])]
       (when dropship?
         [:p "This item will be "
          (help-link app-atom help-article-dropship-deliveries "Dropship-Deliveries"
            "About products shipped directly from suppliers"
            "shipped directly from the supplier.")
          " We do this when items are very big and heavy or require specialist handling. Any other items in your order will be shipped directly from Yuppiechef HQ."])
       (when (yuc/presence geofenced_snippet)
         [:p "This item can only be "
          [:a.text-link.js-mfp-open
           {:href "#" :target_class "js-geofence-shipping-info"}
           "delivered to selected areas"]
          ", as indicated."])
       (if qualifies-free?
         [:p
          [:b "This product qualifies for free delivery to your door."]
          (when-not dropship?
            " But you can choose from a number of delivery options.")]
         [:p "Yuppiechef delivers throughout South Africa."
          (when-not dropship?
            " Choose from a number of delivery options.")])
       [:ul
        [:li (help-link app-atom help-article-delivery-charges "Delivery-Charges"
               "About free delivery"
               "Delivery by courier")
         (str " to your door \u2014 free for orders over R" delivery-threshold)]
        (when-not dropship?
          [:li (help-link app-atom help-article-order-collections "Order-Collections"
                 "Collect your order from a Yuppiechef store"
                 "Collect from a Yuppiechef store")
           " \u2014 free"])
        (when-not dropship?
          [:li (help-link app-atom help-article-postnet-collections "PostNet-Collections"
                 "Collect your order from PostNet"
                 "Collect from your nearest PostNet")
           (str " \u2014 free for orders over R" delivery-threshold)])
        [:li (help-link app-atom help-article-delivery-times "Delivery-Times"
               "How long will my order take to arrive?"
               "How long will my order take to arrive?")]
        [:li (help-link app-atom help-article-sending-as-gift "Sending-my-order-as-a-gift"
               "Sending your order as a gift"
               "Can I send my order as a gift?")]]
       [:h3 "Returns"]
       [:ul
        [:li (help-link app-atom help-article-returns-policy "Yuppiechef-Returns-and-Refunds-Policy"
               "Our returns & repairs policy"
               "30 Day exchanges")]
        [:li (help-link app-atom help-article-returns-policy "Yuppiechef-Returns-and-Refunds-Policy"
               "Our returns & repairs policy"
               "Returns & repairs policy")]]])))


(rum/defc categories-panel < rum/reactive [process-atom]
  (let [{:keys [allcats]} (cmn/curact process-atom :product)
        {:keys [category]} (cmn/curact process-atom :categories)
        current-cat-id (:category/id category)
        current-cat-name (:category/name category)
        visible-cats
        (filter
          (fn [c]
            (and
              ;; :category/product-page-show is a DB 0/1 int — `(not 0)` is false in Clojure.
              (= 1 (:category/product-page-show c))
              (not= (:category/id c) current-cat-id)
              (yuc/presence (:category/page-url c))
              (yuc/presence (:category/anchor-text c))))
          allcats)
        show-current?
        (and
          category
          (yuc/presence (or (:category/anchor-text category) current-cat-name))
          (yuc/presence (:category/page-url category))
          (not= current-cat-name "Featured Products")
          (not= current-cat-name "Products"))]
    (content-panel {:panel-key :categories :title "Similar categories" :process-atom process-atom}
      [:ul.flex-grid-group.flex-grid-group--flush.flex-grid-group--list.flex-grid-group--align-left
       (for [c visible-cats]
         [:li.flex-grid-block.flex-grid-block--small.flex-grid-block--fluid {:key (:category/id c)}
          [:div.flex-grid-content
           [:a.suggested-phrases__button.button.button--raised.button--small.button--rounded.button--secondary.button--bordered
            {:href (str (:category/page-url c) "?ref=productpage")}
            [:span.button__text (:category/anchor-text c)]]]])
       (when show-current?
         [:li.flex-grid-block.flex-grid-block--small.flex-grid-block--fluid {:key "current-cat"}
          [:div.flex-grid-content
           [:a.suggested-phrases__button.button.button--raised.button--small.button--rounded.button--secondary.button--bordered
            {:href (str (:category/page-url category) "?ref=productpage")}
            [:span.button__text (or (:category/anchor-text category) current-cat-name)]]]])])))
